import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// ✅ ADD THIS
import { provideServiceWorker } from '@angular/service-worker';

if (environment.production) {
  const clarityScript = document.createElement('script');
  clarityScript.type = 'text/javascript';
  clarityScript.innerHTML = `
    (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "tjjlmmrikb");
  `;
  document.head.appendChild(clarityScript);
}

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...(appConfig.providers || []),

    // ✅ THIS IS THE MOST IMPORTANT LINE
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production
    })
  ]
})
.catch((err) => console.error(err));